import Common from "../../../Common";

const User = class extends Common {
	async browse(companyId: id, templateId: id) {
		return this.get(`/company/${companyId}/template/${templateId}/user`);
	}

	async browseAvailable(companyId: id, templateId: id) {
		return this.get(`/company/${companyId}/template/${templateId}/user/available`);
	}

	async create(companyId: id, templateId: id, userId: id) {
		return this.post(
			`/company/${companyId}/template/${templateId}/user`,
			{
				pbx_user_id: userId
			}
		);
	}

	async delete(companyId: id, templateId: id, userId: id) {
		return this.doDelete(`/company/${companyId}/template/${templateId}/user/${userId}`);
	}
}

export default User
